import React, { useRef, useState, useEffect } from "react";
import { RiArrowGoBackFill } from "react-icons/ri";
import { FaEraser } from "react-icons/fa";
import { MdFileUpload } from "react-icons/md";
import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const Whiteboard = () => {
    const canvasRef = useRef(null);
    const ctxRef = useRef(null);
    const [isDrawing, setIsDrawing] = useState(false);
    const [color, setColor] = useState("black");
    const [lineWidth, setLineWidth] = useState(3);
    const [history, setHistory] = useState([]);

    useEffect(() => {
        const canvas = canvasRef.current;
        canvas.width = window.innerWidth * 0.8;
        canvas.height = window.innerHeight * 0.8;
        const ctx = canvas.getContext("2d");
        ctx.lineCap = "round";
        ctxRef.current = ctx;
    }, []);

    const startDrawing = (e) => {
        const { offsetX, offsetY } = e.nativeEvent;
        ctxRef.current.beginPath();
        ctxRef.current.moveTo(offsetX, offsetY);
        ctxRef.current.strokeStyle = color;
        ctxRef.current.lineWidth = lineWidth;
        setIsDrawing(true);
    };

    const draw = (e) => {
        if (!isDrawing) return;
        const { offsetX, offsetY } = e.nativeEvent;
        ctxRef.current.lineTo(offsetX, offsetY);
        ctxRef.current.stroke();
    };

    const stopDrawing = () => {
        ctxRef.current.closePath();
        setIsDrawing(false);
        saveHistory();
    };

    const saveHistory = () => {
        const canvas = canvasRef.current;
        setHistory((prevHistory) => [...prevHistory, canvas.toDataURL()]);
    };

    const undoLast = () => {
        if (history.length === 0) return;
        const ctx = ctxRef.current;
        const canvas = canvasRef.current;
        const img = new Image();
        img.src = history[history.length - 1];
        img.onload = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0);
            setHistory((prevHistory) => prevHistory.slice(0, -1));
        };
    };

    const clearCanvas = () => {
        ctxRef.current.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        setHistory([]);
    };

    // Image Upload Handler
    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;
            img.onload = () => {
                const canvas = canvasRef.current;
                const ctx = ctxRef.current;
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                saveHistory();
            };
        };
        reader.readAsDataURL(file);
    };


    return (
        <>
            <div className="container-fluid p-5" style={{ backgroundColor: '#F2F3B7' }}>
                <div className="row">
                    <div className="col-md-1 whiteBoard_sidebar">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <button onClick={clearCanvas} title="Clear all"><FaEraser /></button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <button onClick={undoLast} title="Undo"><RiArrowGoBackFill /></button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input type="color" value={color} onChange={(e) => setColor(e.target.value)} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input
                                            type="range"
                                            min="1"
                                            max="10"
                                            value={lineWidth}
                                            onChange={(e) => setLineWidth(e.target.value)}
                                            style={{ width: '60px' }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleImageUpload}
                                            style={{width:'100px'}}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Image</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-8">
                        <canvas
                            ref={canvasRef}
                            style={{
                                border: "2px solid white",
                                background: "white",
                                cursor: "crosshair",
                                borderRadius: '10px'
                            }}
                            onMouseDown={startDrawing}
                            onMouseMove={draw}
                            onMouseUp={stopDrawing}
                            onMouseOut={stopDrawing}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Whiteboard;